<template>
  <CSidebar
    class="sidebar-theme-light"
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand to="/dashboard.html">
      <img
        class="c-sidebar-brand-minimized"
        size="custom-size"
        :src="SUPPILER_ICON"
        height="50"
        alt=""
      />
      <div>
        <center>
          <img
            class="c-sidebar-brand-full"
            size="custom-size"
            :src="SUPPILER_ICON_FULL"
            height="40"
            alt="Logo"
          />
          <span class="sidebar-brand-flag" title="Việt Nam" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 20" width="26" height="18" focusable="false">
              <rect width="30" height="20" fill="#da251d" rx="1" />
              <polygon fill="#ffcd00" points="15,4.5 16.2,8.2 20.2,8.2 17,10.5 18.2,14.2 15,12 11.8,14.2 13,10.5 9.8,8.2 13.8,8.2" />
            </svg>
          </span>
        </center>
        <span v-if="!minimize" class="sidebar-brand-title-text">QUẢN LÝ TRUYỀN THANH CƠ SỞ</span>
      </div>
    </CSidebarBrand>
    <CRenderFunction flat :contentToRender="navItems"/>
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import { SUPPILER_ICON, SUPPILER_ICON_FULL } from "../constant";
import nav from "./_nav";

export default {
  name: "TheSidebar",
  nav,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  data() {
    return {
      navItems: [],
      SUPPILER_ICON: SUPPILER_ICON,
      SUPPILER_ICON_FULL: SUPPILER_ICON_FULL
    };
  },
  methods: {
    setupNavItemByAuthen() {
      let item = nav.items[0];
      let _item = {};
      let childrens = item._children;
      let _childrens = [];
      _item = this.$helper.cloneObject(item);

      if (_item && childrens instanceof Array) {
        for (let children of childrens) {
          let _children = {};
          let childrenPath = children.to;
          let items = children.items;
          let _items = [];
          if (items && items instanceof Array)
            for (let item of items) {
              let itemPath = item.to;
              if (itemPath && this.$isAuthorized(itemPath)) {
                _items.push(this.$helper.cloneObject(item));
              }
            }
          if (
            _items.length !== 0 ||
            (children._name === "CSidebarNavItem" &&
              this.$isAuthorized(childrenPath))
          ) {
            _children = this.$helper.cloneObject(children);
            _children.items = _items;
            _childrens.push(_children);
          }
        }
      }

      _item["_children"] = _childrens;
      this.navItems = [_item];
    },
  },
  created() {
    this.setupNavItemByAuthen();
  },
  mounted() {
  },
};
</script>
